import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PassengersIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.2 21H5.06667V11.4H7.2V12.4667H8.26667V11.4H10.4V21H8.26667V15.6667H7.2V21Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.73333 2.8667C8.16508 2.8667 8.53968 3.02091 8.85714 3.32935C9.17461 3.63779 9.33333 4.01047 9.33333 4.44742C9.33333 4.88437 9.17461 5.26349 8.85714 5.58477C8.53968 5.90606 8.16508 6.0667 7.73333 6.0667C7.30159 6.0667 6.92699 5.90606 6.60952 5.58477C6.29206 5.26349 6.13333 4.88437 6.13333 4.44742C6.13333 4.01047 6.29206 3.63779 6.60952 3.32935C6.92699 3.02091 7.30159 2.8667 7.73333 2.8667Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.06667 7.13337H10.4C10.9891 7.13337 11.4667 7.61093 11.4667 8.20003V13.5334H4V8.20003C4 7.61093 4.47756 7.13337 5.06667 7.13337Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.7333 21H13.6V11.4H15.7333V12.4667H16.8V11.4H18.9333V21H16.8V15.6667H15.7333V21Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.2667 2.8667C16.6984 2.8667 17.073 3.02091 17.3905 3.32935C17.7079 3.63779 17.8667 4.01047 17.8667 4.44742C17.8667 4.88437 17.7079 5.26349 17.3905 5.58477C17.073 5.90606 16.6984 6.0667 16.2667 6.0667C15.8349 6.0667 15.4603 5.90606 15.1429 5.58477C14.8254 5.26349 14.6667 4.88437 14.6667 4.44742C14.6667 4.01047 14.8254 3.63779 15.1429 3.32935C15.4603 3.02091 15.8349 2.8667 16.2667 2.8667Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.6 7.13337H18.9333C19.5224 7.13337 20 7.61093 20 8.20003V13.5334H12.5333V8.20003C12.5333 7.61093 13.0109 7.13337 13.6 7.13337Z'
                fill='currentColor'
            />
        </>
    ),
})

PassengersIcon.displayName = 'PassengersIcon'
